module.exports = "<p>app-dft-select-search-ngx works!</p>\n"